<template>
  <v-sheet
    class="d-flex align-center"
    color="transparent"
    :height="height"
  >
    <v-container>
      <v-layout justify-center>
        <h1 class="fade-in delay1" style="font-size: 30px; color: grey;">Crypto Pay App</h1>
      </v-layout>
      <v-layout justify-center>
        <h1 class="fade-in delay1" style="font-size: 50px;">Scenario</h1>
      </v-layout>

      <div style="height: 50px;"/>

      <v-layout justify-center>
        <h1 class="fade-in delay2">Abstract</h1>
      </v-layout>

      <div style="height: 20px;"/>
      
      <v-layout justify-center>
        <v-card 
          class="fade-in delay2"
          color="transparent"
          elevation="0"
          width="800" 
        >
          <v-card-text style="font-size: 15px;">
            本アプリはパーミッションドブロックチェーンを使用し、コミュニティ限定の仮想通貨での決済機能を提供します。<br/>
            決済機能の活用により、コミュニティ内での「商品の販売・購入」「参加者間での送金」ができます。<br/><br/>
            
            また、複数の拠点を持つコミュニティにおいても、問題なく仮想通貨を使用したやり取りを行うことできます。<br/>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-sheet>
</template>

<script>
import windowSizeMixin from '../../../mixin/windowSizeMixin'

export default {
  mixins: [windowSizeMixin],

}
</script>

<style>
@import '../../../styles/fade.css';
</style>